module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/disease_key_v-85ecea75fc88109575229a104da6975d.jpg";